package com.downdogapp.client.widget

import com.downdogapp.*
import com.downdogapp.Cursor.POINTER
import com.downdogapp.FontWeight.SEMIBOLD
import com.downdogapp.JustifyContent.CENTER
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.AbstractView
import com.downdogapp.client.resources.Image
import com.downdogapp.client.resources.Images
import com.downdogapp.client.resources.image
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLImageElement
import org.w3c.dom.HTMLSpanElement

class PoseConfirmationView(block: HTMLDivElement.() -> Unit) : AbstractView() {

  private var label: HTMLSpanElement
  private var icon: HTMLImageElement

  fun setText(text: String) {
    label.text = text
  }

  fun setImage(image: Image) {
    icon.image = image
  }

  override val root = createDiv {
    opacity = 0.0
    bgColor = Color.darkGrey(0.8)
    borderRadius = px(8)
    padding = px(10)
    width = px(400)
    height = px(50)
    cursor = POINTER

    horizontalFlexBox(horizontalJustify = CENTER, verticalAlign = AlignItems.CENTER) {
      height = percent(100)
      width = percent(100)

      icon = imageView(Images.THUMBS_UP_ICON) {
        marginRight = px(10)
      }

      label = label(
        text = "",
        color = Color.WHITE,
        fontSize = 14,
        fontWeight = SEMIBOLD,
        textAlign = TextAlign.CENTER
      )
    }

    onClick {
      fadeOut(seconds(0.3))
    }

    block()
  }
}

fun HTMLDivElement.poseConfirmationView(block: HTMLDivElement.() -> Unit): PoseConfirmationView {
  val view = PoseConfirmationView(block)
  append(view.root)
  return view
}
